<template>
  <div class="pre-approval-config">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-content">
        <div class="search-left">
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="自定义检索:" style="margin-right: 6px;">
              <el-select v-model="searchForm.type" placeholder="选择检索类型" style="width: 130px; height: 26px;">
                <el-option label="按产品名称" value="1" />
                <el-option label="按保险公司类型" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item v-show="searchForm.type === '1'" style="margin-right: 0;">
              <el-input
                v-model="searchForm.product_name"
                placeholder="产品名称"
                style="width: 200px; height: 26px;"
                maxlength="100"
                clearable
              />
            </el-form-item>
            <el-form-item v-show="searchForm.type === '2'" style="margin-right: 0;">
              <el-select
                v-model="searchForm.insurance_type"
                placeholder="选择保险公司"
                style="width: 200px; height: 26px;"
                clearable
              >
                <el-option
                  v-for="item in insuranceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item style="margin-right: 0; margin-left: 0;">
              <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">搜索</el-button>
              <el-button @click="handleReset">全部</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="search-right">
          <el-button type="success" @click="handleAdd">
            <i class="el-icon-plus"></i> 添加
          </el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="name" label="产品名称" width="240" align="center" />
      <el-table-column prop="insurance_name" label="保险公司" width="200" align="center" />
      <el-table-column prop="city_list" label="禁止承保区域" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ formatCityList(scope.row.city_list) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="business_scope_keywords" label="营业范围禁止保承关键字" width="300" align="center" />
      <el-table-column prop="company_name_keywords" label="公司名称承保关键字" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ formatCompanyKeywords(scope.row, 'allow') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司名称禁止承保关键字" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ formatCompanyKeywords(scope.row, 'deny') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            type="text"
            :style="{ color: scope.row.disabled ? '#67c23a' : '#f56c6c' }"
            @click="handleToggleStatus(scope.row)"
          >
            {{ scope.row.disabled ? '启用' : '禁用' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.rows"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
      />
    </div>

    <!-- 预核保配置弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <pre-approval-form
        v-if="dialogVisible"
        :form-data="currentRow"
        :is-view="isView"
        @save="handleSave"
        @cancel="handleCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getPreApprovalList, togglePreApprovalStatus, getInsuranceList } from '@/api/product'
import PreApprovalForm from './components/PreApprovalForm.vue'

export default {
  name: 'PreApprovalConfig',
  components: {
    PreApprovalForm
  },
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        type: '1',
        product_name: '',
        insurance_type: ''
      },
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      currentRow: null,
      isView: false,
      insuranceList: []
    }
  },
  mounted() {
    this.fetchData()
    this.fetchInsuranceList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          rows: this.pagination.rows
        }
        
        // 添加搜索条件
        if (this.searchForm.type === '1' && this.searchForm.product_name) {
          params.product_name = this.searchForm.product_name
        } else if (this.searchForm.type === '2' && this.searchForm.insurance_type) {
          params.insurance_type = this.searchForm.insurance_type
        }
        
        const response = await getPreApprovalList(params)
        if (response && response.err_code === 0) {
          this.tableData = response.rows || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error(response?.err_msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取预核保配置列表失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },

    // 获取保险公司列表
    async fetchInsuranceList() {
      try {
        const response = await getInsuranceList()
        if (response && response.err_code === 0) {
          this.insuranceList = response.rows || []
        }
      } catch (error) {
        console.error('获取保险公司列表失败:', error)
      }
    },
    
    // 格式化城市列表
    formatCityList(cityList) {
      if (!cityList || cityList.length === 0) return ''
      return cityList.map(item => `${item.province}${item.city}`).join(', ')
    },

    // 格式化公司名称关键字
    formatCompanyKeywords(row, type) {
      if (type === 'allow' && row.name === '员工保') {
        return row.company_name_keywords || ''
      } else if (type === 'deny' && row.name === '货运险年保') {
        return row.company_name_keywords || ''
      }
      return ''
    },
    
    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        type: '1',
        product_name: '',
        insurance_type: ''
      }
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 新增配置
    handleAdd() {
      this.dialogTitle = '添加预核保产品'
      this.currentRow = null
      this.isView = false
      this.dialogVisible = true
    },
    
    // 查看配置
    handleView(row) {
      this.dialogTitle = '查看产品配置'
      this.currentRow = { ...row }
      this.isView = true
      this.dialogVisible = true
    },
    
    // 编辑配置
    handleEdit(row) {
      this.dialogTitle = '编辑产品配置'
      this.currentRow = { ...row }
      this.isView = false
      this.dialogVisible = true
    },

    // 切换状态
    async handleToggleStatus(row) {
      const action = row.disabled ? '启用' : '禁用'
      try {
        await this.$confirm(`您确认想要${action}吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const response = await togglePreApprovalStatus({
          id: row.id,
          disabled: !row.disabled
        })

        if (response && response.err_code === 0) {
          this.$message.success('修改成功')
          this.fetchData()
        } else {
          this.$message.error(response?.err_msg || '修改失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('切换状态失败:', error)
          this.$message.error('网络错误，请重试')
        }
      }
    },
    
    // 处理保存
    handleSave() {
      this.dialogVisible = false
      this.fetchData()
      this.$message.success('保存成功')
    },
    
    // 处理取消
    handleCancel() {
      this.dialogVisible = false
    },
    
    // 处理弹窗关闭
    handleDialogClose() {
      this.currentRow = null
      this.isView = false
    },
    
    // 每页大小改变
    handleSizeChange(rows) {
      this.pagination.rows = rows
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.pre-approval-config {
  padding: 20px;
}

.search-bar {
  background: #f5f5f5;
  padding: 8px 0;
  margin-bottom: 20px;
  border-radius: 4px;
}

.search-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.search-left {
  flex: 1;
}

.search-right {
  flex-shrink: 0;
}

.search-form {
  margin: 0;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 6px;
}

.search-form .el-form-item__label {
  line-height: 27px;
  margin: 0 6px 0 10px;
}

.pagination-wrapper {
  text-align: center;
  margin-top: 20px;
}
</style>